import axios from "axios"
import { BaseUrl, JsonConfig } from "./BaseRepository"
import { ErrorMessage, InfoMessage, SuccessMessage } from "../Utils/Utils";
import fileDownload from "js-file-download";
import ExcelJS from 'exceljs';
import FileSaver from "file-saver";


export const getAccrualsTableData =  async (from, to) => {
    try{
        let url = `${BaseUrl}Accruals/GetAccrualsDumpData?from=${from}&to=${to}`
        const res = await axios.get(url, JsonConfig);
        if(res.data.statusCode === 200){
            const sample = JSON.parse(res.data.payload);
            return sample;
        }
        else{
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch{
        ErrorMessage("Cannot able to get data");
    }
}

export const downloadAccrualMSXL = async (data) => {
    try{
        if(data.length > 0){
            let loopedList = [];

            // Headers
            loopedList.push([
                'Client Name', 'Date','Associate Name', 'Rate Type', 'Hours','Bill Rate', 
                'Gross Amount','Discount', 'Calculation', 'Net Amount', 'Timesheet Status','File Number',
                'Text', 'File', 'Gross','VMS FEE', 'Notes'
            ]);

            // Function to sanitize only string values

            const sanitizeCellValue = (value) => {
                if(typeof value === 'string' && /^[=+\-@]/.test(value.trim())){
                    return "'" + value; // profix with a single quote only for strings
                }
                return value;
            }

            // Loop through data and ensure numeric values stay as numbers 
            for(let i = 0; i < data.length; i++){
                loopedList.push([
                    sanitizeCellValue(data[i].Client_Name),
                    sanitizeCellValue(data[i].Date),
                    sanitizeCellValue(data[i].Associate_Name),
                    sanitizeCellValue(data[i].Rate_Type),
                    sanitizeCellValue(data[i].Hours),
                    sanitizeCellValue(data[i].Bill_Rate),
                    sanitizeCellValue(data[i].Gross_Amount),
                    sanitizeCellValue(data[i].Discount),
                    sanitizeCellValue(data[i].Calculation),
                    sanitizeCellValue(data[i].Net_Amount),
                    sanitizeCellValue(data[i].Timesheet_Status),
                    sanitizeCellValue(data[i].File_Number),
                    sanitizeCellValue(data[i].Text),
                    sanitizeCellValue(data[i].File),
                    sanitizeCellValue(data[i].Gross),
                    sanitizeCellValue(data[i].VMS_FEE),
                    sanitizeCellValue(data[i].Notes),
                ]);
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');

            // Add rows from loopList
            for(let i = 0; i < loopedList.length; i++){
                worksheet.addRow(loopedList[i]);
            }

            //Export as CSV 
            workbook.csv.writeBuffer()
                .then(buffer => {
                    const blob = new Blob([buffer], {type:'text/csv;charset=utf-8'});
                    FileSaver.saveAs(blob, 'AccrualsGriddata.csv');
                });
            return "downloaded";
        } else {
            return null;
        }
    }
    catch{
        ErrorMessage("Cannot get masterfile data");
        return null;
    }
} 

export const referesAccrualsDate = async () => {
    try{
        const data = {};
        let url = `${BaseUrl}`;
        const res = await axios.post(url,data,JsonConfig);
        if(res.data.statusCode === 200){
            const resp = await getAccrualsTableData();
            SuccessMessage(resp.data.message);
            return resp;
        }
        if(res.data.statusCode === 500){
            InfoMessage(resp.data.message);
            return null
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch(err) {
        ErrorMessage("Cannot able to refresh data, please try again");
        return null;
    }
}